var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeechOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55975 6.80242C1.57072 8.02264 1 9.46054 1 11C1 15.4183 5.70101 19 11.5 19C11.9943 19 12.4807 18.974 12.9568 18.9236C13.0299 18.9955 13.117 19.0585 13.2183 19.1091L16.5146 20.7573L9.75732 14H6C5.44772 14 5 13.5523 5 13C5 12.4477 5.44772 12 6 12H7.75732L5.7166 9.95927C5.39219 9.86358 5.13642 9.60781 5.04073 9.2834L2.55975 6.80242ZM14.2426 10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H12.2426L7.76386 3.52126C8.92463 3.18445 10.184 3 11.5 3C17.299 3 22 6.58172 22 11C22 12.7689 21.2465 14.4036 19.9708 15.7282L17.818 13.5754C17.9327 13.4127 18 13.2142 18 13C18 12.4477 17.5523 12 17 12H16.2426L14.2426 10Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0844727,
    y: 2.16138,
    width: 3,
    height: 32,
    rx: 1.5,
    transform: "rotate(-45 0.0844727 2.16138)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechOff);
export default __webpack_public_path__ + "static/media/speechOff.2c711f12f98e62144e05124182d04ecd.svg";
export { ForwardRef as ReactComponent };